<template>
    <div class="page">
        <el-tabs  :tab-position="tabPosition" style="height: 100%;overflow: auto" v-model='tabs'>
            <el-tab-pane label="基本信息" name="first">
                <el-form :model="mallShop" ref="mallShopForm" style='padding-left: 40px;' :rules="rules" label-width="120px">
                    <el-form-item
                        label="店铺名称"
                        prop="shopName"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.shopName"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label='店铺分类'
                        prop='typeId'
                    >
                        <el-select
                            placeholder='请选择店铺分类'
                            clearable
                            style="width: 400px;"
                            size='small'
                            v-model='mallShop.typeId'
                        >
                            <el-option
                                v-for='(item,index) in typeList'
                                :key='index'
                                :label='item.typeName'
                                :value='item.id'
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label='所属行业'
                        prop='typeId'
                    >
                        <el-select
                            clearable
                            style="width: 400px"
                            v-model="mallShop.industryId"
                            placeholder="请选择"
                            size="small"
                        >
                            <el-tree
                                :data="industryList"
                                :props="treeProps"
                                :render-after-expand="false"
                            >
                                <div
                                    class="custom-tree-node flex items-center"
                                    slot-scope="{ node, data }"
                                >
                                    <el-option
                                        :label="node.label"
                                        :value="data.id"
                                    > </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺位置" prop="shopAddress">
                        <location
                            style="width: 400px;"
                            :areaTreeDate="provinceIdList"
                            :longitude="mallShop.shopPosition.split(',')[0]"
                            :latitude="mallShop.shopPosition.split(',')[1]"
                            :provinceId="mallShop.provinceId"
                            :cityId="mallShop.cityId"
                            :areaId="mallShop.areaId"
                            :streetId="mallShop.streetId"
                            :address="mallShop.shopAddress"
                            @getLocation="getLocation"
                        ></location>
                    </el-form-item>
                    <el-form-item
                        label="所属省份"
                        prop="provinceId"
                    >
                        <el-select
                            placeholder="请选择省"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.provinceId"
                        >
                            <el-option
                                v-for='(item,index) in provinceIdList'
                                :key='index'
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="所属城市"
                        prop="cityId"
                    >
                        <el-select
                            placeholder="请选择市"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.cityId"
                        >
                            <el-option
                                v-for='(item,index) in cityIdList'
                                :key='index'
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="所属区县"
                        prop="areaId"
                    >
                        <el-select
                            placeholder="请选择区"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.areaId"
                        >
                            <el-option
                                v-for='(item,index) in areaIdList'
                                :key='index'
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item
                        label="所属乡镇"
                        prop="streetId"
                        v-if="mallShop.provinceId != 1 && mallShop.provinceId != 2 && mallShop.provinceId != 3 && mallShop.provinceId != 4"
                    >
                        <el-select
                            placeholder="请选择乡镇"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.streetId"
                        >
                            <el-option
                                v-for='(item,index) in streetIdList'
                                :key='index'
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="店铺位定"
                        prop="shopPosition"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.shopPosition"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="营业时间"
                        prop="openHours"
                    >
                        <el-time-picker
                            is-range
                            style="width: 400px;"
                            v-model="mallShop.openHours"
                            range-separator="至"
                            format='HH:mm'
                            value-format='HH:mm'
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item
                        label="店铺标签"
                        prop="shopTags"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.shopTags"
                            @focus="openTabs"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系人姓名"
                        prop="contactPerson"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.contactPerson"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系人电话"
                        prop="contactPhone"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.contactPhone"
                        ></el-input>
                    </el-form-item>
                    <!--el-form-item
                        label="积分抵扣"
                        prop="contactPhone"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.scoreDiscount"
                        ></el-input>
                    </el-form-item-->
                    <el-form-item
                        label="店铺管理"
                        prop="userId"
                    >
                        <GridSelectU
                            style='width: 400px'
                            title='选择用户'
                            labelName='userName'
                            labelValue='id'
                            :value='mallShop.userId'
                            :limit='1'
                            size='small'
                            placeholder='请选择用户'
                            @getValue='getValueUserId'
                            :columns="USER_code"
                            :searchs="USER_search"
                            dataListUrl='/mpp/user/findList'
                            entityBeanName='mppUser'
                            queryEntityUrl='/mpp/user/get'
                        >
                        </GridSelectU>
                    </el-form-item>
                    <el-form-item label="服务费类型" prop="serviceType">
                        <el-select
                            placeholder='请选择服务费类型'
                            clearable
                            style='width: 400px'
                            size='small'
                            v-model='mallShop.serviceType'
                        >
                            <el-option
                                v-for='(item,index) in serviveTypeList'
                                :key='index'
                                :label='item.value'
                                :value='item.key'
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务费比例" prop="serviceRatio" v-if="mallShop.serviceType">
                        <el-input style='width: 400px' size="small" v-model="mallShop.serviceRatio"></el-input>
                    </el-form-item>
<!--                    <el-form-item-->
<!--                        label="可以供货"-->
<!--                        prop="canSupply"-->
<!--                    >-->
<!--                        <el-select-->
<!--                            placeholder="请选择是否可以供货"-->
<!--                            clearable-->
<!--                            style="width: 400px"-->
<!--                            size="small"-->
<!--                            v-model="mallShop.canSupply"-->
<!--                        >-->
<!--                            <el-option-->
<!--                                v-for='(item,index) in yesNoEnumList'-->
<!--                                :key='index'-->
<!--                                :label="item.value"-->
<!--                                :value="item.key"-->
<!--                            >-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item
                        label="销售模式"
                        prop="saleMode"
                    >
                        <el-select
                            placeholder="请选择销售模式"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.saleMode"
                        >
                            <el-option
                                v-for='(item,index) in saleModeEnumList'
                                :key='index'
                                :label="item.value"
                                :value="item.key"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="经营类型"
                        prop="operationType"
                    >
                        <el-select
                            placeholder="请选择经营类型"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.operationType"
                        >
                            <el-option
                                v-for='(item,index) in operationTypeList'
                                :key='index'
                                :label="item.value"
                                :value="item.key"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="限时活动"
                        prop="limitActivity"
                    >
                        <el-select
                            placeholder="请选择是否参与限时活动"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.limitActivity"
                        >
                            <el-option
                                label="开启活动"
                                :value="1"
                            >
                            </el-option>
                            <el-option
                                label="结束活动"
                                :value="0"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="活动结束时间"
                        prop="activityEndTime"
                        v-if="mallShop.limitActivity==1"
                    >
                        <el-date-picker
                            style="width: 400px"
                            size="small"
                            format
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="mallShop.activityEndTime"
                            type="datetime"
                            placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item
                        label="活动类型"
                        prop="activityTypes"
                        v-if="mallShop.limitActivity==1"
                    >
                        <el-select
                            placeholder="请选择活动类型"
                            clearable
                            style="width: 400px"
                            multiple
                            size="small"
                            v-model="mallShop.activityTypes"
                        >
                            <el-option
                                v-for='(item,index) in activityList'
                                :key='index'
                                :label="item.value"
                                :value="item.key"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="店铺公告"
                        prop="shopNotice"
                    >
                        <el-input
                            size="small"
                            type="textarea"
                            :rows="3"
                            style="width: 400px;"
                            v-model="mallShop.shopNotice"
                        ></el-input>
                    </el-form-item>
<!--                    <el-form-item-->
<!--                        label="批发价格"-->
<!--                        prop="wholesalePrice"-->
<!--                        v-if="mallShop.saleMode == 3"-->
<!--                    >-->
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            style="width: 400px;"-->
<!--                            v-model="mallShop.wholesalePrice"-->
<!--                        ></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item-->
<!--                        label="起批数量"-->
<!--                        prop="buyMinLimit"-->
<!--                        v-if="mallShop.saleMode == 3"-->
<!--                    >-->
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            style="width: 400px;"-->
<!--                            v-model="mallShop.buyMinLimit"-->
<!--                        ></el-input>-->
<!--                    </el-form-item>-->
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="审核信息" name="two">
                <el-form :model="mallShop" ref="mallShopForm1" style='padding-left: 40px;' :rules="rules" label-width="120px">
                    <el-form-item
                        label='申请人姓名'
                        prop='applyName'
                    >
                        <el-input
                            size='small'
                            style='width: 400px;'
                            v-model='mallShop.applyName'
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label='申请公司名称'
                        prop='applyCompany'
                    >
                        <el-input
                            size='small'
                            style='width: 400px;'
                            v-model='mallShop.applyCompany'
                        ></el-input>
                    </el-form-item>

                    <el-form-item
                        label="店铺LOGO"
                        prop="shopLogo"
                    >
                        <el-upload
                            style="width: 400px"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="uploadShopLogo"
                        >
                            <img v-if="mallShop.shopLogo" :src="mallShop.shopLogo" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='店铺BANNER'
                        prop='shopBanner'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadBanner'
                        >
                            <img v-if='mallShop.shopBanner' :src='mallShop.shopBanner' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='身份证正面'
                        prop='idcardFront'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadIdcardFront'
                        >
                            <img v-if='mallShop.idcardFront' :src='mallShop.idcardFront' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='身份证反面'
                        prop='idcardBack'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadIdcardBack'
                        >
                            <img v-if='mallShop.idcardBack' :src='mallShop.idcardBack' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='公司营业执照'
                        prop='companyLicense'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadCompanyLicense'
                        >
                            <img v-if='mallShop.companyLicense' :src='mallShop.companyLicense' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="资质图片"
                        prop="qualificationPic"
                    >
                        <div style="display:flex;width: 100%;">
                            <el-upload
                                :headers="header"
                                class="uploadAlbum"
                                :action="action"
                                :on-remove="handleRemove1"
                                :file-list="fileList1"
                                :on-success="handleSuccess1"
                                :before-upload="beforeAvatarUpload1"
                                list-type="picture"
                                accept="jpg,jpeg,png,JPG,JPEG,PNG"
                                :limit="10"
                            >
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div class="bottm-btn">
            <el-button style="margin-left: 30px" type="primary" @click="submitForm">确认添加</el-button>
        </div>
        <!-- 标签列表 -->
        <el-dialog title="标签" :visible.sync="showTabs" width="600px">
            <div>
                <el-form size="small" :inline="true">
                    <el-form-item label="" prop="categoryId">
                        <div style="display: flex">
                            <el-input style="width: 200px;" v-model="keyboards" type="small"></el-input>
                            <el-button type="primary" @click="addTabs" style="margin-left: 10px">添加</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <div style="width: 100%;">
                    <el-button type="danger" plain size="small" icon="el-icon-delete" v-for="(item,index) in tabList"
                               @click="deleteTabs(index)">{{ item }}
                    </el-button>
                </div>
            </div>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeTabs">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Location from '@/components/location/location.vue';
import Tag from '@/components/tag/tag.vue'
import GridSelectU from '@/components/gridselect';
import GridSelect from '@/components/gridselect/brand.vue';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant.js';

export default {
    components: {
        GridSelect,
        GridSelectU,
        Location,
        Tag
    },
    //市
    watch:{
        'mallShop.provinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.mallShop.cityId = '';
                    this.mallShop.areaId = '';
                    this.mallShop.streetId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'mallShop.cityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.mallShop.areaId = '';
                    this.mallShop.streetId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'mallShop.areaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.mallShop.streetId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        'mallShop.limitActivity':{
            handler(val){
                if(val != 1){
                    this.mallShop.activityEndTime = ''
                    this.mallShop.activityTypes = ''
                }
            }
        },
        "mallShop.serviceType":{
            handler(val){
                for (let i = 0; i < this.serviveTypeList.length; i++) {
                    if(this.serviveTypeList[i].key == val){
                        this.mallShop.serviceRatio = this.serviveTypeList[i].value
                    }
                }
            }
        },
    },
    data() {
        return {
            keyboards: '',
            tabList: [],
            showTabs: false,

            USER_code: USER,
            USER_search: USER_SEARCH,
            tabs:'first',
            areaTreeDate: [],
            yesNoEnumList: [],

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            fileList: [],
            fileList1: [],
            temporaryList1: [],
            albumList1: '',
            temporaryList: [],
            albumList: '',
            typeList:[],
            tabPosition: 'left',
            mapDialog: false,
            mallShop: {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                streetId: '',
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: ['08:00','20:00'], //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                scoreDiscount: 0, //积分折扣
                saleMode: 1, //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                shopNotice: '',
                shopTags: '',
                // remarks: '', //备注
                // paymentCode: '', //收款码
                userId: '', //店铺管理
                status: 2, //核审状态
                wholesalePrice: '',
                buyMinLimit: '',
                typeId: '',
                industryId: '',
                operationType: '',
                limitActivity: '',
                activityEndTime: '',
                activityTypes: '',
                serviceType: '',
                serviceRatio: '',
                qualificationPics: ''
            },
            rules: {
                shopName: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
                shopLogo: [{ required: true, message: '店铺logo不能为空', trigger: 'blur' }],
                shopBanner: [{ required: true, message: '店铺banner不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                streetId: [{ required: true, message: '乡镇不能为空', trigger: 'blur' }],
                shopAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                shopPosition: [{ required: true, message: '位定不能为空', trigger: 'blur' }],
                openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
                shopNotice: [{ required: true, message: '公告不能为空', trigger: 'blur' }],
                shopTags: [{ required: true, message: '店铺标签不能为空', trigger: 'blur' }],
                contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                scoreDiscount: [{ required: true, message: '积分抵扣不能为空', trigger: 'blur' }],
                saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
                applyName: [{ required: true, message: '申请人姓名不能为空', trigger: 'blur' }],
                idcardFront: [{ required: true, message: '申请人身份证正面不能为空', trigger: 'blur' }],
                idcardBack: [{ required: true, message: '申请人身份证反面不能为空', trigger: 'blur' }],
                applyCompany: [{ required: true, message: '申请公司名称不能为空', trigger: 'blur' }],
                companyLicense: [{ required: true, message: '公司营业执照不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '核审状态不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
                typeId: [{ required: true, message: '店铺分类不能为空', trigger: 'blur' }],
                industryId: [{ required: true, message: '所属行业不能为空', trigger: 'blur' }],
                operationType: [{ required: true, message: '经营类型不能为空', trigger: 'blur' }],
                limitActivity: [{ required: true, message: '限时活动不能为空', trigger: 'blur' }],
                activityEndTime: [{ required: true, message: '活动结束时间不能为空', trigger: 'blur' }],
                activityTypes: [{ required: true, message: '活动类型不能为空', trigger: 'blur' }],
                serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                serviceRatio: [{ required: true, message: '服务费比列不能为空', trigger: 'blur' }],
            },
            saleModeEnumList: [],
            industryList: [],
            treeProps: {
                children: 'children',
                label: 'industryName'
            },


            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            activityList: [],
            operationTypeList: [],
            serviveTypeList: []
        };
    },
    created() {
        // this.getTreeData();
        this.getYesNoEnum();
        this.getTypeList();
        this.getIndustryList();
        this.getActivityList();
        this.getSaleModeEnumList();
        this.getAddress(1);
    },
    methods:{
        getSaleModeEnumList(){
            get('/mpp/utils/getEnum',{
                enumType: 'sale_mode',
            }).then((res)=>{
                if(res.success){
                    this.saleModeEnumList = res.enumList
                }
            })
            get('/shop/utils/getEnum', { enumType: 'store_service_type' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.serviveTypeList = res.enumList;
                }
            });
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        addTabs() {
            if (this.keyboards) {
                this.tabList.push(this.keyboards);
                this.keyboards = '';
            }
        },
        deleteTabs(key) {
            this.tabList.splice(key, 1);
        },
        openTabs() {
            this.showTabs = true;
            this.tabList = this.mallShop.shopTags == '' ? [] : this.mallShop.shopTags.split(',');
        },
        closeTabs() {
            this.showTabs = false;
            this.mallShop.shopTags = this.tabList.join(',');
            this.tabList = [];
        },
        submitForm() {
            let bool = true
            console.log(this.mallShop,this.albumList1)
            this.$refs.mallShopForm.validate((valid) => {
                if(!valid){
                    bool = false
                    this.tabs = "first"
                    this.$message({
                        message: "请完善基本信息",
                        type: 'error',
                        duration: 2000,
                    });
                    return
                }
            })
            if(!bool){
                return
            }
            this.$refs.mallShopForm1.validate((valid) => {
                if(!valid){
                    bool = false
                    this.tabs = "two"
                    this.$message({
                        message: "请完善审核信息",
                        type: 'error',
                        duration: 2000,
                    });
                }
            })
            if(!bool){
                return
            }
            if(bool){
                console.log('submit');
                this.mallShop.openHours = this.mallShop.openHours.join('-')
                if(this.mallShop.limitActivity == 1){
                    this.mallShop.activityTypes = this.mallShop.activityTypes.join(',')
                }
                this.mallShop.qualificationPics  = this.albumList1;
                post(`/mall/shop/add`,{ ...this.mallShop }).then((res) => {
                    if (res.success && res.code == 200) {
                        this.$router.push('/MallShop/MallShop');
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000,
                        });
                    } else {
                        this.mallShop.openHours = this.mallShop.openHours.split('-')
                        if(this.mallShop.activityTypes != '' && this.mallShop.limitActivity == 1){
                            this.mallShop.activityTypes = this.mallShop.activityTypes.split(',')
                        }
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000,
                        });
                    }
                });
            }
        },
        handleRemove1(file, fileList) {
            console.log(file);
            console.log(this.temporaryList1);
            for (let i = 0; i < this.temporaryList1.length; i++) {
                console.log(file.response.url == this.temporaryList1[i])
                if (file.response.url == this.temporaryList1[i]) {
                    this.temporaryList1.splice(i, 1);
                }
            }
            this.albumList1 = this.temporaryList1.join('|');

            console.log(this.temporaryList1);
        },
        //上传成功
        handleSuccess1(response, file, fileList) {
            console.log(response);
            console.log(file);
            console.log(fileList);
            this.temporaryList1.push(file.response.url);
            console.log(this.temporaryList1);
            this.albumList1 = this.temporaryList1.join('|');
            console.log(this.albumList1);
        },
        beforeAvatarUpload1(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        // 获取所属行业
        getIndustryList(){
            get('/shop/shopindustry/findAllAsTree').then((res)=>{
                if(res.success){
                    this.industryList = res.treeData
                }
            })
        },
        //上传LOGO
        uploadShopLogo(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopLogo = res.url;
                }
            });
        },
        // 获取店铺分类
        getTypeList(){
            get('/shop/shoptype/findAll').then((res)=>{
                if(res.success){
                    this.typeList = res.list
                }
            })
        },
        //上传banner
        uploadBanner(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopBanner = res.url;
                    console.log('this.mallShop.shopBanner',this.mallShop.shopBanner)
                }
            });
        },

        //上传身份证正面
        uploadIdcardFront(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardFront = res.url;
                }
            });
        },

        // 上传身份证反面
        uploadIdcardBack(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardBack = res.url;
                }
            });
        },

        // 上传公司营业执照
        uploadCompanyLicense(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.companyLicense = res.url;
                }
            });
        },

        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (file.response.url == this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.albumList = this.temporaryList.join('|');
        },
        handleSuccess(response, file, fileList) {
            this.temporaryList.push(file.response.url);
            this.albumList = this.temporaryList.join('|');
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        getTreeData(){
            get('/mpp/area/treeData').then((res)=>{
                if(res.success){
                    this.areaTreeDate = res.treeData[0].children
                }
            })
        },
        // 获取yes_no枚举
        getYesNoEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'yes_no',
            }).then((res)=>{
                if(res.success){
                    this.yesNoEnumList = res.enumList
                }
            })
        },
        getActivityList(){
            get('/shop/utils/getEnum',{enumType: 'shop_shop_activity_type'}).then((res)=>{
                if(res.success){
                    this.activityList = res.enumList
                }
            })
            get('/shop/utils/getEnum',{enumType: 'shop_operation_type'}).then((res)=>{
                if(res.success){
                    this.operationTypeList = res.enumList
                }
            })
        },
        getLocation(location){
            this.mallShop.shopPosition = `${location.lng},${location.lat}`
            this.mallShop.shopAddress = location.address
            this.getCity = true
            this.getArea = true
            this.street = true
            this.mallShop.provinceId = location.province
            this.mallShop.cityId = location.city
            this.mallShop.areaId = location.area
            this.mallShop.streetId = location.street
        },
        clearSubitem(id){
            if (id == 'province'){
                this.mallShop.cityId = ""
                this.mallShop.areaId = ""
            } else if (id == 'city') {
                this.mallShop.areaId = ""
            }
        },
        getValueUserId(value){
            this.mallShop.userId = value
        },
    }
};
</script>
<style scoped lang="scss">
.page{
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 30px;
}
.bottm-btn{
    margin-top: 20px;
    padding-left: 100px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
    width: 400px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 400px;
    height: 200px;
    display: block;
}
::v-deep .el-upload--text {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 400px;
    height: 200px;
}
.avatarWide {
    width: 200px;
    height: 120px;
}

</style>